import { useBreakpointValue } from '@chakra-ui/react';

import { appRatio } from '@/config.json';

const CONTENT_FLEX = appRatio - 1;

function useAuthLayoutBreakpoint() {
    const minH = useBreakpointValue({ base: 'auto', md: '100vh' });
    const py = useBreakpointValue({ base: '3', md: '6' });
    const px = useBreakpointValue({
        base: '4',
        md: `calc((100% - 100% / ${appRatio}) / 2)`,
    });

    return {
        minH,
        px,
        py,
    };
}

export { useAuthLayoutBreakpoint, CONTENT_FLEX };
